const FormateTime = ({ timeInSecond }: { timeInSecond: number }) => {
  const hours = Math.floor(timeInSecond / 3600);
  const minutes = Math.floor((timeInSecond % 3600) / 60);
  const seconds = timeInSecond % 60;

  if (hours > 0) {
    return `${hours} hours, ${minutes} minutes`;
  }
  if (hours === 0 && minutes > 0) {
    return `${minutes} minutes, ${seconds} seconds`;
  }
  if (hours === 0 && minutes === 0) {
    return `${seconds} seconds`;
  }
  return;
};

export default FormateTime;
